import { useState, useCallback } from 'react';
import { ValueLabel } from '..';
import { compose as lcompose, map as lmap, find, propOr } from 'lodash/fp';

export const useToggle = ({ init }: { init: ValueLabel<boolean>[] }) => {
  const [values, setValues] = useState<ValueLabel<boolean>[]>(init);

  const value = useCallback(
    (name: string) => {
      return lcompose(
        propOr(false, 'value'),
        find<ValueLabel<boolean>>({ label: name })
      )(values);
    },
    [values]
  );

  const toggle = useCallback(
    (name: string) => {
      return lcompose(
        setValues,
        lmap<ValueLabel<boolean>, ValueLabel<boolean>>(({ label, value }) => ({
          label,
          value: label === name ? !value : value,
        }))
      )(values);
    },
    [values]
  );

  const off = useCallback(
    (name: string) => {
      return lcompose(
        setValues,
        lmap<ValueLabel<boolean>, ValueLabel<boolean>>(({ label, value }) => ({
          label,
          value: label === name ? false : value,
        }))
      )(values);
    },
    [values]
  );

  return { value, toggle, off };
};
